export const formatLabel = string => {
  return string
    .replace(/id/gi, 'ID')
    .replace(/[\.\-_]+/g, ' ')
    .trim()
}
